import * as React from "react";
import Dropdown from "../Dropdown/Dropdown";
import Input from "../Input-new/Input";

const SellerCompanyInfo = ({data, handleChangeInput, handleChangeDropdown, viewMode, deleted}) => {
    function getCompanyZIP()
    {
        // if(viewMode == true && typeof data.COMPANY_ZIP !== 'undefined' && data.COMPANY_ZIP != null && data.COMPANY_ZIP.length < 5)
        //     {
        //         data.COMPANY_ZIP = '0'.repeat(5 - data.COMPANY_ZIP.length) + data.COMPANY_ZIP
        //     }
        //     if(data.COMPANY_ZIP == null || data.COMPANY_ZIP == '00000' || data.COMPANY_ZIP == '')
        //     {
        //         data.COMPANY_ZIP = ''
        //     }
        //     return data.COMPANY_ZIP;
        if(viewMode == true && typeof data.company_zip !== 'undefined' && data.company_zip != null && data.company_zip.length < 5)
        {
            data.company_zip = '0'.repeat(5 - data.company_zip.length) + data.company_zip
        }
        if(data.company_zip == null || data.company_zip == '00000' || data.company_zip == '')
        {
            data.company_zip = ''
        }
        return data.company_zip;
    }
    return (
        <div className="Seller-company-info">
            <div className="Seller-company-info_column">
                <Input
                    className="Seller-company-info_column_item"
                    //name="COMPANY_NAME"
                    name="company_name"
                    label="Company Name"
                    //value={data.COMPANY_NAME}
                    value={data.company_name}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Seller-company-info_column_item"
                    //name="COMPANY_ADDRESS"
                    name="company_address"
                    label="Company Address"
                    //value={data.COMPANY_ADDRESS}
                    value={data.company_address}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Seller-company-info_column_item"
                    //name="COMPANY_CITY"
                    name="company_city"
                    label="City"
                    //value={data.COMPANY_CITY}
                    value={data.company_city}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Seller-company-info_column_item"
                    data={data}
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    // value={data.COMPANY_STATE}
                    // valueKey="COMPANY_STATE"
                    value={data.company_state}
                    valueKey="company_state"
                    label="State"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input  
                    className="Seller-company-info_column_item"
                    //name="COMPANY_ZIP"
                    name="company_zip"
                    label="Zip"
                    value= {getCompanyZIP()}                               
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            </div>
        </div>
    );
};

export default SellerCompanyInfo;
